// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './polyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import axios from 'axios'
import VueNotifications from 'vue-notifications'
import firebase from 'firebase'
import 'firebase/performance'
import { firestorePlugin } from 'vuefire'
import { ClientTable } from 'vue-tables-2'
import moment from 'moment'
import VueMomentJS from 'vue-momentjs'
import miniToastr from 'mini-toastr' //npm install --save https://github.com/se-panfilov/mini-toastr
import JsonExcel from 'vue-json-excel'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import VueAnalytics from 'vue-analytics'
import App from './App'
import router from './router/index'
import store from './store/store'

// Initialize Firebase
const config = {
  apiKey: "AIzaSyB6M9kqjJpeCuVQ1GqxdM7IOqoM2DVqyDk",
  authDomain: "sharp-imprint-234606.firebaseapp.com",
  databaseURL: "https://sharp-imprint-234606.firebaseio.com",
  projectId: "sharp-imprint-234606",
  storageBucket: "sharp-imprint-234606.appspot.com",
  messagingSenderId: "975620609596"
}

firebase.initializeApp(config)

Sentry.init({
  dsn: 'https://5522c6cc9813493b9246e9b2e107e648@sentry.io/1775655',
  integrations: [new Integrations.Vue({ Vue, attachProps: true })],
})

Vue.use(firestorePlugin)
Vue.use(ClientTable)
Vue.use(VueMomentJS, moment)
Vue.use(BootstrapVue)
Vue.use(VueLodash, { name: 'custom', lodash})
Vue.use(VueAnalytics, {
  id: 'G-P2LT2YTE1Z',
  router
})

Vue.prototype.$http = axios
Vue.prototype.$firebase = firebase

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}
miniToastr.init({types: toastTypes})
function toast({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}
const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}
Vue.use(VueNotifications, options)

Vue.filter('beautify', (value) => {
  if (value === null) return ''
  //firebase Timestamp object
  if (value.hasOwnProperty('seconds') && value.hasOwnProperty('nanoseconds')) {
    return moment.unix(value.seconds).format('YYYY-MM-DD HH:mm:ss')
  }
  return value;
})

Vue.component('downloadExcel', JsonExcel)

const needLogin = (path) => {
  if (store.state.user) return false
  if (path === '/pages/login') return false
  if (path === '/pages/resetPassword') return false
  if (path === '/pages/verifyEmail') return false
  if (path === '/pages/login') return false
  if (path === '/pages/404') return false
  if (path === '/pages/500') return false

  return true;
}

router.beforeEach((to, from, next) => {
    if (needLogin(to.path)) {
      next('/pages/login')
    } else {
      next()
    }
  })
  
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  store,
  components: {
    App
  }
})
